<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">选择类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.speech_type" placeholder="请选择">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">选择提示词类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.type" placeholder="请选择">
              <el-option
                v-for="item in promptlist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">演讲报告提示词<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.ai_prompt"></textarea>
            <span>最多输入30个以内的中文</span>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.speech_type==1?'费曼练习':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'AI改稿':''">{{item.speech_type==1?'费曼练习':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'AI改稿':''}}</p>
              <p :title="item.ai_prompt">{{item.ai_prompt}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAiPromptList,saveAiPrompt,delAiPrompt,getAiPromptDetail ,saveFixedLexicon,getFixedLexiconDetail } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'16',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'提示词类型'},
        {id:3,title:'演讲报告提示词'},
        {id:4,title:'添加时间'},
        {id:5,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        speech_type:1,
        type:1,
        ai_prompt:'',
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'费曼练习'},
        {id:2,title:'30秒黄金自我介绍'},
        {id:3,title:'备稿演讲'},
        {id:4,title:'即兴演讲'},
        {id:5,title:'演讲评估'},
        {id:6,title:'AI改稿'},
      ],
      promptlist:[
        {id:1,title:'文本'},
        {id:2,title:'视频'},
        {id:3,title:'录音'},
      ],
      wordType:false,
      wordObj:{
        words:[
          {title:'',keyword:'',language:1}
        ]
      }
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getAiPromptList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getAiPromptDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          that.addType = 'edit';
          console.log(that.addObj.sort)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delAiPrompt({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.ai_prompt == ''){
        that.$message('请输入提示词！');
        return false;
      }
      
      try {
        const response = await saveAiPrompt(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        speech_type:1,
        type:1,
        ai_prompt:'',
      };
    },
    
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-word-add{
    color: #6E2FFF;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    padding: 11px 34px;
    display: block;
    margin-top: 30px;
    font-size: 18px;
  }

  .btn-word-remove{
    background-color: #E2231A;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 11px 52px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
  }

  .wordBox{
    height: calc( 100% - 100px );
  }

  .wordBox .word-item{
    margin-bottom: 20px;
    display: block;
    background-color: #fff;
    box-sizing: border-box;
    padding: 40px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/prompt/index.vue